import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: './home/home.module#HomePageModule'
  },
  {
    path: 'list',
    loadChildren: './list/list.module#ListPageModule'
  },
  { path: 'meditation', loadChildren: './meditation/meditation.module#MeditationPageModule' },
  { path: 'visualization', loadChildren: './visualization/visualization.module#VisualizationPageModule' },
  { path: 'images', loadChildren: './images/images.module#ImagesPageModule' },
  { path: 'book', loadChildren: './book/book.module#BookPageModule' },
  { path: 'login', loadChildren: './login/login.module#LoginPageModule' },
  { path: 'signup', loadChildren: './signup/signup.module#SignupPageModule' },
  { path: 'profil', loadChildren: './profil/profil.module#ProfilPageModule' },
  { path: 'affirmations', loadChildren: './affirmations/affirmations.module#AffirmationsPageModule' },
  { path: 'exercice', loadChildren: './exercice/exercice.module#ExercicePageModule' },
  { path: 'welcome', loadChildren: './welcome/welcome.module#WelcomePageModule' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
